import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchAdministrationTransporteurs } from 'store/administration/administrationActions';
import { patchTransporteur } from 'store/administration/administrationActions';
import AdministrationTransporteur from './AdministrationTransporteur';
import withLoader from 'components/Shared/withLoader';

const AdministrationTransporteurWithLoader = withLoader(AdministrationTransporteur);

class AdministrationTransporteurContainer extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            transporteur: null
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationTransporteurs();

        let { id, transporteurs } = this.props;

        if (id && id !== 0) {
            let transporteur = transporteurs.find(x => x.id === id);
            

            this.setState({
                transporteur: JSON.parse(JSON.stringify(transporteur)),
            });
        }
    }
           


    handleChange = (event) => {
        let newTransporteur = this.state.transporteur;

        if (event.target.name === 'nom') {
            newTransporteur.nom = event.target.value;
        }

        if (event.target.name === 'type') {
            newTransporteur.type = event.target.value;
        }

        this.setState({ ...this.state, transporteur: newTransporteur });
    };


    handleChangeCode = (index, value) => {
        var newState = { ...this.state };
        newState.transporteur.transporteursLogistique[index].code = value;
        this.setState(newState);
    };

    handleChangeCompte = (index, value) => {
        var newState = { ...this.state };
        newState.transporteur.transporteursLogistique[index].transporteurCompteId = value;
        this.setState(newState);
    };
    
    handleClickAddCode = () => {
        this.setState({
            ...this.state,
            transporteur: {
                ...this.state.transporteur,
                transporteursLogistique: [...this.state.transporteur.transporteursLogistique, { code: 'nouveau code' }]
            }
        });
    };


    handleClickRemoveCode = (index) => {
        var newState = { ...this.state };
        newState.transporteur.transporteursLogistique.splice(index, 1);        
        this.setState(newState);
    };

    handleClickCancel = (event) => {
        this.setState({
            transporteur: null
        });
    };

    handleClickSave = async (event, id) => {
        await this.props.patchTransporteur(this.state.transporteur);
        this.setState({
            transporteur: null
        });
    };



    render() {
        const { isLoading, isPatching } = this.props;
        const { transporteur } = this.state;

        let sauvegardable = !transporteur || (transporteur.nom.length > 0);


        return (
            <AdministrationTransporteurWithLoader
                isLoading={isLoading}
                isPatching={isPatching}
                
                selectedTransporteur={transporteur}

                onChange={this.handleChange}
                onClickCancel={this.handleClickCancel}
                onClickSave={this.handleClickSave}         

                onClickAddCode={this.handleClickAddCode}
                onClickRemoveCode={this.handleClickRemoveCode}
                onChangeCode={this.handleChangeCode}
                onChangeCompte={this.handleChangeCompte}
                

                sauvegardable={sauvegardable}
            />);
    }
}

AdministrationTransporteurContainer.propTypes = {
    id: PropTypes.number
};

const mapStateToProps = state => ({
    isLoading: state.administration.transporteurs.isLoading,
    isPatching: state.administration.transporteurs.isPatching,
    transporteurs: state.administration.transporteurs.items
});

const mapDispatchToProps = dispatch => ({
    fetchAdministrationTransporteurs: () => dispatch(fetchAdministrationTransporteurs()),
    patchTransporteur: (transporteur) => dispatch(patchTransporteur(transporteur)),
    
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationTransporteurContainer);